export default __webpack_public_path__ + "static/media/Handshake.c54ec091.svg";